import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Report_Fields: {[id:string]: ISearchProviderField } = {

    WB_REPORT_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB REPORT Id', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    REPORT_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REPORT_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Name', columnResourceName: 'colReportName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REPORT_DESCRIPTION:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Description', columnResourceName: 'colReportDesc', alignment: HorizAlignment.Left}, domainOptions: {}},
    REPORT_SUBJECT:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Subject', columnResourceName: 'colReportSubject', alignment: HorizAlignment.Left}, domainOptions: {}},
    REPORT_KEYWORDS:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Keywords', columnResourceName: 'colReportKeywords', alignment: HorizAlignment.Left}, domainOptions: {}},
    REPORT_TYPE_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Report Type ID', columnResourceName: 'colReportTypeId', alignment: HorizAlignment.Left}, domainOptions: {}}, 
    RENDER_OPTIONS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Render Options', columnResourceName: 'colRenderOptions', alignment: HorizAlignment.Left}, domainOptions: {}},
    TREE_PATH:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path', columnResourceName: 'colTreepath', alignment: HorizAlignment.Left}, domainOptions: {}},
    METRIC_VERSIONS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Versions', columnResourceName: 'colMetricVersions', alignment: HorizAlignment.Left}, domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const ReportSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_REPORT_ID',
                id_ui: 'REPORT_ID',
                name:  'REPORT_NAME'
    },

    searchProviderFields: vUI_Report_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Report_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const ReportSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "By Id, Name",
    renderOptions: { ui5ResourceId: "ReportSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'REPORT_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'REPORT_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'REPORT_ID','REPORT_NAME','REPORT_DESCRIPTION','REPORT_SUBJECT','REPORT_KEYWORDS','REPORT_TYPE_ID','RENDER_OPTIONS','TREE_PATH','METRIC_VERSIONS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ReportSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const ReportSearch: ISearch = {
    searchName: "Find Report",
    renderOptions: { ui5ResourceId: "ReportSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ReportSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("ReportBO", "Report", ReportSearch, "Report Search")

export {ReportSearch}